import { ChangeDetectionStrategy, Component, forwardRef, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MsfInput } from '@components/ui/forms/input/input';
import { CheckboxComponent } from '@components/checkbox/checkbox.component';
import { SecondaryButton } from '@components/button/secondary-button/secondary-button';
import { ConfigField, ConfigListChange } from './config-json-form';

@Component({
  selector: 'app-config-json-fields',
  standalone: true,
  imports: [
    FormsModule,
    TranslateModule,
    MsfInput,
    CheckboxComponent,
    SecondaryButton,
    forwardRef(() => ConfigJsonFieldsComponent),
  ],
  templateUrl: './config-json-fields.html',
  styleUrl: './config-json-fields.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigJsonFieldsComponent {
  readonly fields = input.required<ConfigField[]>();
  readonly fieldChange = output<ConfigField>();
  readonly listChange = output<ConfigListChange>();

  onText(field: ConfigField, value: string | number | null): void {
    this.fieldChange.emit({ ...field, value: value ?? '' });
  }

  onBoolean(field: ConfigField, value: boolean): void {
    this.fieldChange.emit({ ...field, value });
  }

  onChild(field: ConfigField): void {
    this.fieldChange.emit(field);
  }

  onList(change: ConfigListChange): void {
    this.listChange.emit(change);
  }

  addItem(field: ConfigField): void {
    this.listChange.emit({ op: 'add', path: field.path });
  }

  removeItem(item: ConfigField): void {
    this.listChange.emit({ op: 'remove', path: item.path });
  }
}
